module.exports = __webpack_public_path__ + "static/media/ss.67001d2a.svg";